module.exports = __webpack_public_path__ + "assets/radio.79ccc7b2.svg";